import { Navigate, useOutletContext } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import type { RouteContext } from 'modules/employees/lib/types'

import TerminatePage from './TerminatePage'

/**
 * Protected wrapper for TerminatePage that ensures proper permission checking.
 *
 * Since TerminatePage renders a modal inside EmployeeRootPage (child route),
 * we can't use <NotFound /> as it would only show in the outlet area.
 * Instead, we redirect back to the employee profile page.
 */
const ProtectedTerminatePage = () => {
  const context = useOutletContext<RouteContext>()
  const { canTerminateEmployee, employee } = context
  const { navigation } = useNavigation()

  // Redirect to employee profile if user doesn't have permission
  if (!canTerminateEmployee) {
    return <Navigate to={navigation.employees.id.fullPath({ id: employee.id })} replace />
  }

  // User has permission, render the terminate modal
  return <TerminatePage />
}

export default ProtectedTerminatePage
